$(document).ready(function() {
  $('.show-more-colors').on('click', function() {
    $(this).remove()
    $('.swatch .swatch-element.color-hide').removeClass('color-hide')
  return false;
  })
  
  new Swiper('.product-default .swiper-container', {
      slidesPerView: 'auto',
      spaceBetween: 30,
      loop: true,
      speed: 1000,
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
    });
  
  $('.vid .play').on('click', function() {
    iframe = $(this).parents('.vid').find('iframe')
    iframe.attr('src', iframe.attr('src') + '?autoplay=1')
    $(this).parent().addClass('show')
  	return false
  })
 
  $('.product-recommendations-related .products-grid').slick({
    accessibility: false,
    dots: false,
    arrows: false,
    adaptiveHeight: true,
    slidesToShow: 4,
    slidesToScroll: 4,
    responsive: [
      {
		breakpoint: 992,
        settings: {
          slidesToShow: 3,
    slidesToScroll: 3,
          dots: true
        }
      },
      {
		breakpoint: 768,
        settings: {
          slidesToShow: 2,
    slidesToScroll: 2,
          dots: true
        }
      }
    ]
  })
 
  $('section.features .slider').slick({
    accessibiity: false,
    dots: true,
    arrows: false,
    adaptiveHeight: true,
    slidesToShow: 3,
    slidesToScroll: 3,
    responsive: [
      {
		breakpoint: 992,
        settings: {
          slidesToShow: 2,
    slidesToScroll: 2,
        }
      },
      {
		breakpoint: 768,
        settings: {
          slidesToShow: 1,
    slidesToScroll: 1,
        }
      }
    ]
  })
  
  $('section.video-slider .slider').on('afterChange', function() {
  	$('section.video-slider .above').removeClass('show')
    $('section.video-slider iframe').attr('src', '')
  })
 
  $('section.video-slider .slider').slick({
    accessibility: false,
    dots: true,
    arrows: false
  })
  
  $('section.video-slider .vid .above').on('click', function() {
  	$(this).addClass('show')
    $(this).next().attr('src', $(this).next().attr('data-src'))
  })
  
  $('.a-tabs .a-tabs-nav li a').on('click', function() {
    if (!$(this).is('.active')) {
		$('.a-tabs .active').removeClass('active')
       index = $(this).parent().index()
       $(this).addClass('active')
       $('.a-tabs .a-tab').eq(index).addClass('active')
    }
  return false
  })
  
  if ($('#shopify-product-reviews').length) {
    timer = setInterval(function() {
    rating = $('.spr-badge').attr('data-rating')
   $('#shopify-product-reviews .spr-summary-starrating').attr('data-rating', rating)
    }, 1000)
    
    setTimeout(function() {
    clearInterval(timer)
    }, 5000)
  }
  
  $('.sidebar-tags-collections label').on('click', function() {
  	location.href = '/collections/' + $(this).prev().attr('value')
  })
  
  $('.home-slideshow [data-video-mp4] video').on( 'click', function (){
    if( $(this).prop('muted') )
    {
      $(this).parent().addClass('mute-off')
        $(this).prop('muted', false);
    } else {
      $(this).parent().removeClass('mute-off')
    $(this).prop('muted', true);
    }

  });

  $('body').on('click', '.item-swatch li .label', function() {
    location.href = $(this).attr('data-href')
  });

  $('*').removeAttr('tabindex').removeAttr('aria-label').removeAttr('aria-disabled').removeAttr('aria-disabled').removeAttr('role');

  /* UK Detect */
  $.get("http://ipinfo.io", function(response) {
    if ( response.country == "GB" ) {
      
      $('.uk-popup-wrap').addClass('shown');
    }
  }, "jsonp");

  $('.uk-popup-content .close-popup').on('click', function() {
    $('.uk-popup-wrap').removeClass('shown');
  });

  $('.uk-popup-wrap').on('click', function(e) {
    if ( ! $(e.target).is('.uk-popup-content, .uk-popup-content *') ) {
      $('.uk-popup-wrap').removeClass('shown');
    }
  });
})